// src/App.tsx
import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import AuthProvider from 'react-auth-kit';
import RequireAuth from '@auth-kit/react-router/RequireAuth'
import createStore from 'react-auth-kit/createStore';
import Home from "./components/Home"; // The protected home component
import NotFound from "./components/NotFound"; // A simple 404 page
import Login from './components/Login'; // Login page handled by APISIX

interface IUserData {
    name: string;
    uuid: string;
   };
   
   const store = createStore<IUserData>({
    authName:'_auth',
    authType:'cookie',
    cookieDomain: window.location.hostname,
    cookieSecure: window.location.protocol === 'https:'
   })

const App: React.FC = () => {
  return (
    <AuthProvider store={store}>
      <Router>
        <Routes>
          {/* Public route for login would be handled by APISIX */}
          <Route path="/login" element={<Login />} />

          {/* Protected route for home */}
          <Route
            path="/home"
            element={
              <RequireAuth fallbackPath="/login">
                <Home />
              </RequireAuth>
            }
          />

          {/* Catch-all route for 404 */}
          <Route path="*" element={<NotFound />} />

          {/* Default route redirects to home */}
          <Route path="/" element={<Navigate to="/home" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
